module.exports = __webpack_public_path__ + "img/customer_small@2x.ef1f6fbd.jpg";